<!-- wrapper for your modals -->
<template>
  <modal
    :adaptive="true"
    name="work-modal"
    class="base-modal-inner js-base-modal-inner relative"
    @before-open="beforeOpen"
    @opened="beforeOpen"
    @before-close="beforeClose"
  >
    <button class="base-modal__close" @click="closeModal">
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.5 9.32843L15.435 16.2635L16.8492 14.8492L9.91421 7.91421L16.2635 1.56497L14.8492 0.150757L8.5 6.5L2 0L0.585786 1.41421L7.08579 7.91421L0 15L1.41421 16.4142L8.5 9.32843Z"
          fill="currentColor"
        />
      </svg>
    </button>
    <div class="modalWorkpackages__title">
      {{ text }}
    </div>
  </modal>
</template>
  <script>
  import Vue from 'vue'
  import vmodal from 'vue-js-modal'
  import { disableBodyScroll, clearAllBodyScrollLocks } from '@/assets/js/lock-scroll'
  Vue.use(vmodal)

  export default {
    name: 'BaseModal',

    data: function () {
      return {
        text: ''
      }
    },

    watch: {
      '$route' () {
        this.closeModal()
      },
      modalValue (val) {
        this.$parent.$emit('modal-change', val)
      }
    },

    methods: {
      beforeOpen (event) {
        this.text = event.params.text
        const el = this.$refs.target || this.$el
        disableBodyScroll(el)
      },
      closeModal () {
        this.$modal.hide('work-modal')
      },
      beforeClose () {
        clearAllBodyScrollLocks()
      }
    }
  }
  </script>

  <style lang="scss">
  .v--modal-background-click {
    background: rgba(0, 0, 0, 0.87);
  }

  .base-modal {
    display: flex;
    flex-direction: column;
    align-items: center;

    &-inner {
      position: relative;
      max-height: 90vh;
      margin: 0 24px;
      z-index: 99999;

      @include mobile {
        max-width: none;
        margin: 0 auto;
      }
    }
  }

  .base-modal__close {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 5;
    color: $c-black;
    cursor: pointer;
    background: unset;
    border: unset;

    @include mobile {
      top: 8px;
      right: 8px;
    }
  }

  .vm--modal {
    height: min-content !important;
  }
  </style>
